import { render } from "./TsFooter.vue?vue&type=template&id=d9eb8586&scoped=true"
import script from "./TsFooter.vue?vue&type=script&lang=js"
export * from "./TsFooter.vue?vue&type=script&lang=js"

import "./TsFooter.vue?vue&type=style&index=0&id=d9eb8586&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9eb8586"]])

export default __exports__